export { default as SystemSoftwares } from './systemSoftwares.container';
